exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".refresh-btn{align-self:flex-end}.inline-heading{width:100%;display:inline-flex;justify-content:space-between;align-items:flex-end}.admin-settings-tracking-first-column{width:16rem;color:white}.admin-settings-tracking-stop-start{margin-left:0px !important}.tracking-off-toggle{--fa-secondary-color: #e02b25 !important;--fa-secondary-opacity: 1.0}.revision-entry{color:#20232a !important;display:flex;align-items:center;justify-content:space-between;padding-top:5px;padding-bottom:5px}\n", ""]);

// exports
